// extracted by mini-css-extract-plugin
module.exports = {"sg8kopq":"sg8kopq"};